/** Caddy'nin platform/yonetim alt alanlarını aynı dağıtımda eşleştirir. */
export function yonetimAdresi(
  platformAdresi: string,
  yapilandirilanAdres?: string,
): URL {
  if (yapilandirilanAdres?.trim()) {
    const hedef = new URL(yapilandirilanAdres.trim());
    if (!["http:", "https:"].includes(hedef.protocol)) {
      throw new Error("Yönetim paneli adresi HTTP veya HTTPS olmalıdır.");
    }
    return hedef;
  }

  const hedef = new URL(new URL(platformAdresi).origin);
  if (["localhost", "127.0.0.1", "[::1]"].includes(hedef.hostname)) {
    hedef.port = "5175";
  } else if (hedef.hostname.startsWith("platform.")) {
    hedef.hostname = hedef.hostname.replace(/^platform\./, "yonetim.");
  } else {
    throw new Error("Yönetim paneli adresi belirlenemedi. VITE_YONETIM_URL ayarını kontrol edin.");
  }
  return hedef;
}
